export const METRIC_LABEL = 'Specified Metric';
export const MULTIPLE_LABEL = 'Specified Multiple';
export const NO_GPC_MULTIPLES = 'Create a GPC approach to reference the multiples or specify a multiple here';
export const NO_FINANCIAL_STATEMENT = 'Provide financials to reference those metrics or specify a metric amount here';
